<template>
  <v-card outlined light class="rounded-md">
    <v-container style="background-color: #479acc">
      <v-row>
        <v-col cols="auto" class="pa-6" align-self="center">
          <v-card-title
            primary-title
            style="text-align: left"
            class="pa-0"
            color="white"
          >
            <span
              style="
                font-family: Inter;
                color: white;
                font-size: 18px;
                line-height: 18px;
              "
            >
              <v-icon small color="white" style="margin-top: -3px"
                >mdi-clock-outline</v-icon
              >
              Activity
            </span>
          </v-card-title>
        </v-col>
        <v-spacer></v-spacer>
        <v-col v-if="false" cols="auto" class="px-6 py-3" align-self="center">
          <v-btn text icon color="white" @click="$emit('addNewIngestor')">
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-col class="pa-6 py-4">
      <activity-alert
        v-for="alert in activityAlerts"
        :key="alert.key"
        :alert="alert"
        :node="node"
        :is-connected="isConnected"
        @value-copied="handleValueCopied"
      />
    </v-col>
    <v-snackbar v-model="showToast" :timeout="2000" bottom>
      {{ toastMessage }}
    </v-snackbar>
  </v-card>
</template>

<script>
import ActivityAlert from './ActivityAlert.vue';

export default {
  components: {
    ActivityAlert,
  },
  props: {
    node: {
      type: Object,
      default() {
        return {};
      },
    },
    isConnected: {
      type: Boolean,
      default: false,
    },
    activityAlerts: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      showToast: false,
      toastMessage: '',
    };
  },
  methods: {
    handleValueCopied(message) {
      this.toastMessage = message;
      this.showToast = true;
    },
  },
};
</script>
